import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilitiesService } from '../utilities/utilities.service';

@Injectable({
  providedIn: 'root'
})
export class TrackRequestService {
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),

  };
  private translations = {
    en: {
      new_connection: 'New Connection',
      site_office_connection: 'Site office connection',
      network_relocation: 'Relocation of network element',
      demolition_and_contstruction: 'Demolition and Construction',
      plot_extension: 'Plot extension',
      backup_link: 'Backup link',
    },
    ar: {
      new_connection: 'تمديدات جديدة',
      site_office_connection: 'تمديدات لمكتب موقع مؤقت',
      network_relocation: 'نقل الشبكة المتأثرة',
      demolition_and_contstruction: 'هدم وإعادة بناء',
      plot_extension: 'إضافة لمساحة الأرض',
      backup_link: 'خط إحتياطي',
    },
  };
  constructor(private http: HttpClient, private UTS: UtilitiesService) { }

  // trackRequest(cqRefNo) {
    //   const payload = { "cqRefNo": cqRefNo };
//   return this.http.post(
  //     `${environment.BASE_URL}/cqTrackRequest`,
  //     payload,
  //     this.httpOptions
  //   );
  // }

  trackRequest(cqRefNo, isVerifiedUser = false, noCache = false) {
    const payload = { cqRefNo, isVerifiedUser };
    const params = new HttpParams().set('noCache', String(noCache));
  
    return this.http.post(
      `${environment.BASE_URL}/cqTrackRequest`,
      payload,
      { ...this.httpOptions, params }
    );
  }

  handleCQOperations(payload) {
    return this.http.post(
      `${environment.BASE_URL}/handleCQOperations`,
      payload,
      this.httpOptions
    );
  }

  getReqTypeTranslation(reqType){
    const lang = (localStorage.getItem('language') && localStorage.getItem('language').length) ? localStorage.getItem('language') : 'en';
    const key = Object.keys(this.translations['en'])?.find(
      (key) =>  this.translations['en'][key]?.toLowerCase() == reqType?.toLowerCase()
    );
    if (key) {
      const lang = localStorage.getItem('language') || 'en';
      return this.translations[lang][key] || reqType;
    } else {
      return reqType;
    }
  }

}
